import { heroEquipment } from "../HeroEquipment";

export const karnawałChaosu = {
  heroes: {
    "Mistrz karnawału": {
      id: 0,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 70,
      number: 1,
      equipmentList: heroEquipment["Karnawał Chaosu"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Czarnoksięstwo",
        "Dowódca",
        "Mag (Dziedzina Chaosu)",
        "Stygmat Chaosu",
      ],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    Poskramiacz: {
      id: 1,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 35,
      number: 1,
      equipmentList: heroEquipment["Karnawał Chaosu"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Treser", "Stygmat Chaosu"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Harlekin: {
      id: 2,
      startingEquipment: ["Sztylet", "Broń miotana (noże)"],
      cost: 35,
      number: 3,
      equipmentList: heroEquipment["Karnawał Chaosu"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 4, 3, 3, 1, 4, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Gadanina", "Niepokojący", "Stygmat Chaosu"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Mocarz: {
      id: 3,
      startingEquipment: ["Sztylet", "Broń wielka"],
      cost: 35,
      number: 3,
      equipmentList: heroEquipment["Karnawał Chaosu"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 4, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Krzepki", "Siłacz", "Stygmat Chaosu"],
      exp: 8,
      skills: [0, 3, 5],
    },
    Kultysta: {
      id: 4,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 12,
      equipmentList: heroEquipment["Karnawał Chaosu"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Chorążowie & sygnaliści", "Żywa tarcza"],
    },
    "Furia Chaosu": {
      id: 5,
      startingEquipment: ["Broń naturalna (szybki)"],
      cost: 45,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        "Początkowa": [4,4,0,4,3,1,4,2,6],
        "Maksymalna": [4,4,0,4,3,4,4,2,6]
      },
      rules: ["Demon", "Głód krwi", "Lot"],
    },
    "Piekielny ogar": {
      id: 6,
      startingEquipment: ["Broń naturalna (zabójczy cios)"],
      cost: 45,
      number: 3,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [8, 5, 0, 4, 3, 1, 4, 1, 8],
        Maksymalna: [8, 5, 0, 4, 3, 1, 4, 1, 8],
      },
      rules: [
        "Demon",
        "Furia",
        "Odporność na magię (2)",
        "Rączy",
        "Stygmaty Khorna (skoczek)",
      ],
    },
    "Nurgling": {
      id: 7,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 35,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 0, 3, 4, 1, 3, 1, 7],
        Maksymalna: [4, 2, 0, 3, 4, 1, 3, 1, 7],
      },
      rules: ["Demon", "Stygmaty Nurgla (odór, rój much)"],
    },
    "Bólożądna pieszczota": {
      id: 8,
      startingEquipment: ["Broń naturalna (szybki)"],
      cost: 45,
      number: 3,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [5, 4, 0, 4, 3, 1, 5, 3, 8],
        Maksymalna: [5, 4, 0, 4, 3, 1, 5, 3, 8],
      },
      rules: [
        "Demon",
        "Niepokojący",
        "Stygmaty Slaanesha (ogon skorpiona, ponętny, szczypce)",
      ],
    },
    "Różowy strachulec": {
      id: 9,
      startingEquipment: ["Broń naturalna (przebicie pancerza)"],
      cost: 45,
      number: 3,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 0, 3, 3, 1, 3, 1, 8],
        Maksymalna: [4, 2, 0, 3, 3, 1, 3, 1, 8],
      },
      rules: [
        "Demon",
        "Istota magiczna (Dziedzina Tzeentcha)",
        "Strachulce",
        "Stygmat Chaosu",
        "Żywiołak Chaosu",
      ],
    },
    Tyralier: {
      id: 10,
      startingEquipment: ["Sztylet","Miecz","Łuk","Rumak chaosu","Siodło & uprząż"],
      cost: 80,
      number: 3,
      equipmentList: heroEquipment["Karnawał Chaosu"]["Tyralier"],
      type: "Stronnik",
      stats: {
        "Początkowa": [4,3,3,3,3,1,3,1,7],
        "Maksymalna": [5,6,6,4,4,3,6,4,9],
        "Rumak Chaosu": [8,3,0,4,"-","-",3,1,5]
      },
      rules: [
        "Akrobata",
        "Kawalerzysta",
        "Lekka jazda",
        "Pewny strzał",
        "Wspinaczka",
      ],
    },
    "Ogar Chaosu": {
      id: 11,
      startingEquipment: ["Broń naturalna"],
      cost: 20,
      number: 5,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [7, 4, 0, 4, 3, 1, 3, 1, 5],
        Maksymalna: [7, 4, 0, 4, 3, 1, 3, 1, 5],
      },
      rules: ["Rączy", "Zwierzę"],
    },
    "Troll Chaosu": {
      id: 12,
      startingEquipment: ["Broń naturalna"],
      cost: 200,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        "Początkowa": [6,3,1,5,4,3,1,3,4],
        "Maksymalna": [6,3,1,5,4,3,1,4,4]
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Głupota",
        "Nieświadomy",
        "Niezłomny",
        "Przepastne trzewia",
        "Regeneracja",
        "Strach",
        "Stygmat Chaosu",
        "Wielkolud",
        "Żrąca plwocina",
        "Żywiołak Chaosu",
      ],
    },
    Karawan: {
      id: 13,
      startingEquipment: [],
      cost: 200,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        "Powóz": ["-","-","-",4,8,8,"-","-","-"],
        "Rumak Chaosu": [8,3,0,4,"-","-",3,1,5],
        "Rumak Chaosu ": [8,3,0,4,"-","-",3,1,5],
        "Furman": ["-",3,"-",3,"-","-",4,1,7]
      },
      rules: [
        "Demon",
        "Duży cel",
        "Furman",
        "Karawan",
        "Machina wojenna",
        "Powóz",
        "Znachor",
      ],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 12,
  name: "Karnawał Chaosu",
  nature: "Chaotyczna",
  armyRules: [
    "Niewolnicy ciemności",
    "Oko Chaosu",
    "Podatek",
    "Rozrzutność",
    "Znak Chaosu",
  ],
  mercenaries: [],
};
